import React from 'react';
import Icon from '../../../components/AppIcon';

const ContractOverview = () => {
  const contractDetails = [
    { label: "Contract Type", value: "Master Service Agreement", icon: "FileText" },
    { label: "Effective Date", value: "January 1, 2025", icon: "Calendar" },
    { label: "Term Length", value: "24 months", icon: "Clock" },
    { label: "Contract Value", value: "$2,500,000", icon: "DollarSign" },
    { label: "Renewal Terms", value: "Auto-renewal (12 months)", icon: "RotateCcw" },
    { label: "Governing Law", value: "Delaware, USA", icon: "Scale" }
  ];

  const keyTerms = [
    {
      title: "Service Level Agreement",
      description: "99.9% uptime guarantee with monthly reporting requirements",
      icon: "CheckCircle"
    },
    {
      title: "Payment Terms",
      description: "Net 30 days with 2% early payment discount if paid within 10 days",
      icon: "CreditCard"
    },
    {
      title: "Termination Clause",
      description: "90-day written notice required for termination without cause",
      icon: "AlertTriangle"
    },
    {
      title: "Intellectual Property",
      description: "All work product remains property of client organization",
      icon: "Shield"
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
        <div className="flex items-center space-x-2 mb-6">
          <Icon name="FileText" size={20} className="text-primary" />
          <h2 className="text-xl font-semibold text-foreground">Contract Overview</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contractDetails?.map((detail, index) => (
            <div key={index} className="space-y-2">
              <div className="flex items-center space-x-2">
                <Icon name={detail?.icon} size={16} className="text-muted-foreground" />
                <label className="text-sm font-medium text-muted-foreground">
                  {detail?.label}
                </label>
              </div>
              <p className="text-base text-foreground font-medium pl-6">
                {detail?.value}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-6 shadow-sm">
        <div className="flex items-center space-x-2 mb-6">
          <Icon name="List" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Key Terms & Conditions</h3>
        </div>
        
        <div className="space-y-4">
          {keyTerms?.map((term, index) => (
            <div key={index} className="flex items-start space-x-4 p-4 bg-muted/50 rounded-lg">
              <div className="flex-shrink-0 p-2 bg-success/10 rounded-lg">
                <Icon name={term?.icon} size={18} className="text-success" />
              </div>
              <div className="flex-1">
                <p className="text-base text-foreground font-medium mb-1">
                  {term?.title}
                </p>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {term?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContractOverview;